module.exports = __webpack_public_path__ + "static/media/den_norske_kirke.f53f14bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/den_norske_kirke.png
// module id = 726
// module chunks = 0